import SurveyList from "@/features/survey/list";

const Surveys = () => {
  return <SurveyList />;
};

export default Surveys;
